import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from '../components/form.css';
import MysketchPicker from '../../../components/MysketchPicker/MysketchPicker';
import Table from '../Table/Table';
import Collapse, { Panel } from '../../../components/Collapse/Collapse';

const initQuery = {
  name: '',
  mua: null,
  kol: null,
  color: ''
};

class FavorForm extends Component {
  constructor (props) {
    super(props);
  }
  state = {
    editIndex: null,
    ...Object.assign({}, initQuery),
    errorStatus: {
      state: false,
      msg: ''
    }
  }

  handleChange (type, e) {
    this.setState({
      [type]: typeof e === 'string' ? e : e.target.value
    })
  }

  handleClick = () => {
    const { onChange, list } = this.props;

    const { editIndex, color, name, kol, mua } = this.state

    if (name === '') {
      setTimeout(() => {
        this.setError(false, '')
      }, 2000)
      return this.setError(true, '请输入标签')
    }

    if (typeof editIndex === 'number') {
      list[editIndex] = { color, name, kol, mua }
      this.setState({editIndex: null})
    } else {
      list.push({
        color, 
        name, 
        kol: kol || 0, 
        mua: mua || 0
      })
    }

    onChange({}, list);

    // 重置表单
    this.setState({
      ...Object.assign({}, initQuery)
    })
  }
  setError = (state, msg) => {
    this.setState({
      errorStatus: {
        state, msg
      }
    })
  }

  renderColorCake = (color) => {
    const style = {
      display: 'inline-block',
      height: 20,
      width: 20,
      background: color,
      verticalAlign: 'middle'
    }
    return <span style={style}></span>
  }

  remove = (index) => {
    const {list, onChange} = this.props;
    list.splice(index, 1)
    onChange({}, list);
  }

  edit = (index) => {
    const {list} = this.props;
    const item = list[index]
    this.setState({
      editIndex: index,
      name: item.name,
      mua: item.mua,
      kol: item.kol,
      color: item.color
    })
  }

  clear = () => {
    const { onChange } = this.props;
    onChange({}, []);
  }

  render () {
    const {list} = this.props;
    
    const {editIndex, name, kol, mua, color, errorStatus} = this.state;

    return (
      <Collapse className={s.collapse}>
        <Panel header="数据" expand>
          <div><button onClick={this.clear}>清空数据</button></div>

          <div style={{display: 'flex', justifyContent: 'space-between', marginTop: 10}}>
            <input style={{width: 120}} value={name} onChange={e=>{this.handleChange('name', e)}} placeholder="标签" />
            <input type="number" style={{width: 120}} value={mua} onChange={e=>{this.handleChange('mua', e)}}  placeholder="mua" />
            <input type="number" style={{width: 120}} value={kol} onChange={e=>{this.handleChange('kol', e)}}  placeholder="kol" />
            <MysketchPicker value={color} onChange={e=>{this.handleChange('color', e)}} />
            <button onClick={this.handleClick}>{typeof editIndex === 'number' ? '修改' : '添加'}</button>
          </div>
          {errorStatus.state && <p style={{color: '#f00'}}>{errorStatus.msg}</p>}

          <Table 
            header={() =>
              <tr>
                <th>标签</th>
                <th>mua</th>
                <th>kol</th>
                <th>颜色</th>
                <th style={{width:150}}>操作</th>
              </tr>
            }
            body={() => list.map((item, index) => 
              <tr key={index}>
                <td>{item.name}</td>
                <td>{item.mua}</td>
                <td>{item.kol}</td>
                <td>{this.renderColorCake(item.color)}</td>
                <td>
                  <button onClick={() => this.edit(index)}>修改</button>
                  <button onClick={() => this.remove(index)}>删除</button>
                </td>
              </tr>  
            )}
          />
        </Panel>
      </Collapse>
    )
  }
}

export default withStyles(s)(FavorForm)


// WEBPACK FOOTER //
// src/routes/customChart/Favor/FavorForm.js